import { useState, useEffect } from 'react';
import { useLanguage } from '../utils/i18n';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
    const { t } = useLanguage();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            // Small delay so it doesn't flash immediately
            const timer = setTimeout(() => setVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            padding: '0 16px 16px',
            pointerEvents: 'none',
            animation: 'slideUpCookie 0.4s ease-out'
        }}>
            <div style={{
                maxWidth: 520,
                margin: '0 auto',
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(16px)',
                WebkitBackdropFilter: 'blur(16px)',
                border: '1px solid var(--border)',
                borderRadius: 16,
                padding: '20px 24px',
                pointerEvents: 'auto',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
            }}>
                <p style={{
                    fontSize: 13,
                    lineHeight: 1.5,
                    color: 'var(--text-muted)',
                    margin: '0 0 16px'
                }}>
                    🍪 {t('cookie_text')}{' '}
                    <Link to="/privacy" style={{ color: 'var(--primary)', textDecoration: 'underline' }}>
                        {t('cookie_policy_link')}
                    </Link>
                </p>
                <div style={{ display: 'flex', gap: 10 }}>
                    <button
                        onClick={handleAccept}
                        style={{
                            flex: 1,
                            padding: '10px 0',
                            background: 'var(--primary)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 10,
                            fontSize: 13,
                            fontWeight: 700,
                            cursor: 'pointer',
                            transition: 'opacity 0.2s'
                        }}
                    >
                        {t('cookie_accept')}
                    </button>
                    <button
                        onClick={handleDecline}
                        style={{
                            flex: 1,
                            padding: '10px 0',
                            background: 'transparent',
                            color: 'var(--text-muted)',
                            border: '1px solid var(--border)',
                            borderRadius: 10,
                            fontSize: 13,
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'opacity 0.2s'
                        }}
                    >
                        {t('cookie_decline')}
                    </button>
                </div>
            </div>

            <style>{`
        @keyframes slideUpCookie {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
        </div>
    );
}
